import { styled } from '@mui/material/styles';
import { Paper, Box, Grid, Typography, Button } from '@mui/material';

export const CenteredGrid = styled(Grid)(() => ({
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(3),
    borderRadius: theme.shape.borderRadius * 2,
}));

export const FormBox = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(1),
}));

export const SubmitButton = styled(Button)(({ theme }) => ({
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
}));

export const MessageText = styled(Typography)(() => ({
    marginBottom: 16,
    textAlign: 'center',
}));

export const SuccessMessage = styled(MessageText)(({ theme }) => ({
    color: theme.palette.success.main,
}));

export const ErrorMessage = styled(MessageText)(({ theme }) => ({
    color: theme.palette.error.main,
}));